export const ACTION = {
    download: "Download",
    delete: "Delete",
  };